module.exports = __webpack_public_path__ + "img/whatsbuy_code.5d25ab5f.png";